@if (update(); as u) {
  <div class="flex min-h-full flex-col bg-page">
    <div class="px-6 pt-6">
      <h1 class="ds-h2 text-ink-1">{{ u.name }} {{ u.version }}</h1>
      <div class="mt-1.5 text-xs text-ink-2">
        {{ u.displayTechnology }} · {{ formatSize(u.size) }} · md5 {{ truncateChecksum(u.checksum) }} · uploaded by
        {{ u.uploadedBy }} on {{ u.createdAt | date: 'EEE MMM d · HH:mm' }}
      </div>

      <div class="mt-5 flex gap-6 border-b border-hairline">
        <button
          type="button"
          class="ds-h3 pb-3 text-ink-3"
          [class.text-ink-1]="activeTab() === 'assign'"
          [class.shadow-[inset_0_-2px_0_var(--ink-1)]]="activeTab() === 'assign'"
          (click)="selectTab('assign')"
        >
          Assign devices
        </button>
        <button
          type="button"
          class="ds-h3 flex items-center gap-2 pb-3 text-ink-3"
          [class.text-ink-1]="activeTab() === 'rollout'"
          [class.shadow-[inset_0_-2px_0_var(--ink-1)]]="activeTab() === 'rollout'"
          (click)="selectTab('rollout')"
        >
          Rollout
          @if (assignedCount(); as count) {
            <app-label-badge>{{ count }}</app-label-badge>
          }
        </button>
      </div>
    </div>

    <div class="flex min-h-0 flex-1 flex-col">
      @switch (activeTab()) {
        @case ('assign') {
          <app-assign-devices-tab [update]="u" (assigned)="onAssigned()" />
        }
        @case ('rollout') {
          <app-rollout-tab [update]="u" />
        }
      }
    </div>
  </div>
} @else if (isLoading()) {
  <!-- Header skeleton on the loaded layout's geometry (title, meta line,
       tab bar); the tab content mounts after the update arrives. -->
  <div class="grid-skeleton px-6 pt-6" aria-hidden="true">
    <div class="h-6 w-72 animate-pulse rounded bg-surface-2"></div>
    <div class="mt-2.5 h-3 w-96 max-w-full animate-pulse rounded bg-surface-2"></div>
    <div class="mt-6 flex gap-6 border-b border-hairline pb-3.5">
      <div class="h-4 w-28 animate-pulse rounded bg-surface-2"></div>
      <div class="h-4 w-20 animate-pulse rounded bg-surface-2"></div>
    </div>
  </div>
}
